import React, { Component } from 'react'
import { BackOfficeAlert } from './BackOfficeAlert'
import { FrontOfficeAlert } from './FrontOfficeAlert'
import './Alert.css'
import PropTypes from 'prop-types'

export class AdjustemntAlert extends Component {
  static propTypes = {
    isBackOffice: PropTypes.bool,
    adjustment: PropTypes.object,
    downloadReceipt: PropTypes.func,
    onPay: PropTypes.func,
  }
  render () {
    return (
      <div className={'adjustmentAlert ' + this.props.isBackOffice ? 'back' : 'front'}>
        {this.props.isBackOffice ? (
          <BackOfficeAlert
            downloadReceipt={this.props.downloadReceipt}
            adjustment={this.props.adjustment}
            onPay={this.props.onPay}
          />
        ) : (
          <FrontOfficeAlert
            downloadReceipt={this.props.downloadReceipt}
            adjustment={this.props.adjustment}
            onPay={this.props.onPay}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alert/AdjustemntAlert.js